import { render, staticRenderFns } from "./ConsultantDocument.vue?vue&type=template&id=4d355e00&"
import script from "./ConsultantDocument.vue?vue&type=script&lang=js&"
export * from "./ConsultantDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports